import React, { Component } from 'react';
import { Col, Row, Badge } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import Collapse from 'react-bootstrap/Collapse';
import classes from './SalesAndIncomeTable.module.css';
import DetailRow from './DetailRow';

class SummaryPanel extends Component {
	state = {
		transactionDetails: false,
		salesDetails: false,
		incomeDetails: false,
		cashStock: false
	};
	sumaryCollapsOpener = (value, name) => {
		let open = value;
		this.setState({ [name]: !open });
	};

	render() {
		const { t } = this.props;
		return (
			<Form>
				<Form.Group>
					<Row className={classes.SummaryRow}>
						<Col xs={12} sm={6} md={4} lg={4}>
							<Form.Label>{t('salesSnadIncome.transactions')}</Form.Label>
						</Col>
						<Col xs={12} sm={6} md={2} lg={2}>
							<Row >
								<Col
									xs={6}
									sm={6}
									md={6}
									lg={6}
									style={{
										display: 'flex',
										justifyContent: 'flex-end',
										marginRight: '5px'
									}}
								>
									{this.props.transactionSum}
								</Col>
								<Col xs={5} sm={5} md={5} lg={5}>
									{t('salesSnadIncome.summary.piece')}
								</Col>
							</Row>
						</Col>
						<Col xs={12} sm={12} md={12} lg={12}>
							<Badge
								className={classes.Detail}
								onClick={() =>
									this.sumaryCollapsOpener(
										this.state.transactionDetails,
										'transactionDetails'
									)
								}
								aria-expanded={this.state.transactionDetails}
							>
								{t('salesSnadIncome.summary.details')}
								<i
									className={
										!this.state.transactionDetails
											? 'fa fa-caret-down ml-2'
											: 'fa fa-caret-up ml-2'
									}
								></i>
							</Badge>
							<Collapse in={this.state.transactionDetails}>
								<Col className={classes.DetailPanel}>
									<DetailRow
										name={t('salesSnadIncome.summary.purchaseCash')}
										measure={t('salesSnadIncome.summary.piece')}
										label={this.props.purchaseCashTrSum}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.purchaseCashless')}
										measure={t('salesSnadIncome.summary.piece')}
										label={this.props.purchaseCashlessTrSum}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.purchaseWallet')}
										measure={t('salesSnadIncome.summary.piece')}
										label={this.props.purchaseWalletTrSum}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.topUpCash')}
										measure={t('salesSnadIncome.summary.piece')}
										label={this.props.topUpCashTrSum}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.topUpCashless')}
										measure={t('salesSnadIncome.summary.piece')}
										label={this.props.topUpCashlessTrSum}
										style={{ borderColor: 'transparent' }}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.undefinedSource')}
										measure={t('salesSnadIncome.summary.piece')}
										label={this.props.undefinedSum}
										style={{ borderColor: 'transparent' }}
									/>
								</Col>
							</Collapse>
						</Col>
					</Row>

					<Row className={classes.SummaryRow}>
						<Col xs={12} sm={6} md={4} lg={4}>
							<Form.Label>{t('salesSnadIncome.failedTransactions')}</Form.Label>
						</Col>
						<Col xs={12} sm={6} md={2} lg={2}>
							<Row >
								<Col
									xs={6}
									sm={6}
									md={6}
									lg={6}
									style={{
										display: 'flex',
										justifyContent: 'flex-end',
										marginRight: '5px'
									}}
								>
									{this.props.failedTransactionSum}
								</Col>
								<Col xs={5} sm={5} md={5} lg={5}>
									{t('salesSnadIncome.summary.piece')}
								</Col>
							</Row>
						</Col>
					</Row>

					<Row className={classes.SummaryRow}>
						<Col xs={12} sm={6} md={4} lg={4}>
							<Form.Label>{t('salesSnadIncome.sales')}</Form.Label>
						</Col>
						<Col xs={12} sm={6} md={2} lg={2}>
							<Row >
								<Col
									xs={6}
									sm={6}
									md={6}
									lg={6}
									style={{
										display: 'flex',
										justifyContent: 'flex-end',
										marginRight: '5px'
									}}
								>
									{this.props.priceSum}
								</Col>
								<Col xs={5} sm={5} md={5} lg={5}>
									{this.props.measure}
								</Col>
							</Row>
						</Col>
						<Col xs={12} sm={12} md={12} lg={12}>
							<Badge
								className={classes.Detail}
								onClick={() =>
									this.sumaryCollapsOpener(
										this.state.salesDetails,
										'salesDetails'
									)
								}
								aria-expanded={this.state.salesDetails}
							>
								{t('salesSnadIncome.summary.details')}
								<i
									className={
										!this.state.salesDetails
											? 'fa fa-caret-down ml-2'
											: 'fa fa-caret-up ml-2'
									}
								></i>
							</Badge>
							<Collapse in={this.state.salesDetails}>
								<Col className={classes.DetailPanel}>
									<DetailRow
										name={t('salesSnadIncome.summary.purchaseCash')}
										measure={this.props.measure}
										label={this.props.purchaseCashPriceSum}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.purchaseCashless')}
										measure={this.props.measure}
										label={this.props.purchaseCashlessPriceSum}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.purchaseWallet')}
										measure={this.props.measure}
										label={this.props.purchaseWalletPriceSum}
										style={{ borderColor: 'transparent' }}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.undefinedSource')}
										measure={this.props.measure}
										label={this.props.undefinedPriceSum}
										style={{ borderColor: 'transparent' }}
									/>
								</Col>
							</Collapse>
						</Col>
					</Row>

					<Row className={classes.SummaryRow}>
						<Col xs={12} sm={6} md={4} lg={4}>
							<Form.Label>{t('salesSnadIncome.income')}</Form.Label>
						</Col>
						<Col xs={12} sm={6} md={2} lg={2}>
							<Row >
								<Col
									xs={6}
									sm={6}
									md={6}
									lg={6}
									style={{
										display: 'flex',
										justifyContent: 'flex-end',
										marginRight: '5px'
									}}
								>
									{this.props.incomeSum}
								</Col>
								<Col xs={5} sm={5} md={5} lg={5}>
									{this.props.measure}
								</Col>
							</Row>
						</Col>
						<Col xs={12} sm={12} md={12} lg={12}>
							<Badge
								className={classes.Detail}
								onClick={() =>
									this.sumaryCollapsOpener(
										this.state.incomeDetails,
										'incomeDetails'
									)
								}
								aria-expanded={this.state.incomeDetails}
							>
								{t('salesSnadIncome.summary.details')}
								<i
									className={
										!this.state.incomeDetails
											? 'fa fa-caret-down ml-2'
											: 'fa fa-caret-up ml-2'
									}
								></i>
							</Badge>
							<Collapse in={this.state.incomeDetails}>
								<Col className={classes.DetailPanel}>
									<DetailRow
										name={t('salesSnadIncome.summary.purchaseCash')}
										measure={this.props.measure}
										label={this.props.purchaseCashIncomeSum}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.purchaseCashless')}
										measure={this.props.measure}
										label={this.props.purchaseCashlessIncomeSum}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.topUpCash')}
										measure={this.props.measure}
										label={this.props.topUpCashIncomeSum}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.topUpCashless')}
										measure={this.props.measure}
										label={this.props.topUpCashlessIncomeSum}
										style={{ borderColor: 'transparent' }}
									/>
								</Col>
							</Collapse>
						</Col>
					</Row>
					<Row
						className={classes.SummaryRow}
						style={{ borderColor: 'transparent' }}
					>
						<Col xs={12} sm={6} md={4} lg={4}>
							<Form.Label>{t('salesSnadIncome.cashStock')}</Form.Label>
						</Col>
						<Col xs={12} sm={6} md={2} lg={2}>
							<Row >
								<Col
									xs={6}
									sm={6}
									md={6}
									lg={6}
									style={{
										display: 'flex',
										justifyContent: 'flex-end',
										marginRight: '5px'
									}}
								>
									{this.props.cashSum}
								</Col>
								<Col xs={5} sm={5} md={5} lg={5}>
									{this.props.measure}
								</Col>
							</Row>
						</Col>
						<Col xs={12} sm={12} md={12} lg={12}>
							<Badge
								className={classes.Detail}
								onClick={() =>
									this.sumaryCollapsOpener(this.state.cashStock, 'cashStock')
								}
								aria-expanded={this.state.cashStock}
							>
								{t('salesSnadIncome.summary.details')}
								<i
									className={
										!this.state.cashStock
											? 'fa fa-caret-down ml-2'
											: 'fa fa-caret-up ml-2'
									}
								></i>
							</Badge>
							<Collapse in={this.state.cashStock}>
								<Col className={classes.DetailPanel}>
									<DetailRow
										name={t('salesSnadIncome.summary.purchaseCash')}
										measure={this.props.measure}
										label={this.props.purchaseCashStock}
									/>
									<DetailRow
										name={t('salesSnadIncome.summary.topUpCash')}
										measure={this.props.measure}
										label={this.props.topUpCashStock}
										style={{ borderColor: 'transparent' }}
									/>
								</Col>
							</Collapse>
						</Col>
					</Row>
				</Form.Group>
			</Form>
		);
	}
}

export default withTranslation()(SummaryPanel);
